import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { HelmetProvider } from 'react-helmet-async';
render(<HelmetProvider data-id="element-439" data-mp="1wbd080vlbrii">
    <App data-id="element-440" data-mp="1wcxtzoa2z6fb" />
  </HelmetProvider>, document.getElementById('root'));